import React from "react";
import { menuSelect } from "../../types/initStore/initUi";
import { CardLocation } from "../Card/CardLocation";
import { ButtonSecondary } from "../Button/ButtonSecondary";
import { Assets } from "../../assets";
import { NotificationTutorial } from "../Notification/NotificationTutorial";
import { NotificationInit } from "../Notification/NotificationInit";

export const ContainerDesktop = ({
	loading = false,
	iconHeader = "",
	optionSelect = 0,
	selectMenu = menuSelect.principal,
	cardLocationMenu = [],
	nameselect = "Edificios",
	actionOptionMenu = () => {
		console.log("select");
	},
	backMenu = () => {
		console.log("menu1");
	},
	actionMoveLocation = () => {
		console.log("menu1");
	},
	actionModalInformation = () => {
		console.log("modal");
	},
}) => {
	return (
		<>
			<div
				className={`relative w-[340px]  bg-grayBackground70 border-4 rounded-2xl border-secondary grid 
                ${selectMenu > menuSelect.principal ? "h-[690px] grid-rows-containerMenu2" : "h-[600px] grid-rows-containerMenu1"}
                `}
			>
				<NotificationTutorial />
				<NotificationInit />
				<div className={`w-[70px] h-[250px] absolute z-10 -left-12 top-[43%]`}>
					<img className="h-full w-full" src={Assets.general.simbolodesktop} alt="simbolo" />
				</div>
				<div
					className={`bg-white70 overflow-hidden rounded-t-2xl ${
						selectMenu > menuSelect.principal ? "flex pl-[70px] items-center" : "py-6"
					}`}
				>
					<HeaderCard type={selectMenu} nameselect={nameselect} icon={iconHeader} />
				</div>
				<div className="px-10 py-8 overflow-y-auto flex flex-col gap-4 ">
					{cardLocationMenu.map(({ id, name, menuSelect: menu, background, icon }, index) => (
						<CardLocation
							selectId={optionSelect}
							key={`${index}-cardLocation`}
							name={name}
							icon={icon}
							id={id}
							background={background}
							action={() => {
								if (!loading) {
									if (selectMenu === menuSelect.principal) {
										actionOptionMenu(id, menu);
									} else if (selectMenu === menuSelect.secondary) {
										actionMoveLocation(id);
									} else {
										actionModalInformation(true, id, `move-${index}`);
									}
								}
							}}
						/>
					))}
				</div>
				<div
					className={` ${
						selectMenu === menuSelect.principal && "hidden"
					} flex items-center justify-center gap-4 px-4 bg-grayGeneral rounded-b-2xl`}
				>
					<ButtonSecondary name="regresar" action={backMenu} />
				</div>
			</div>
		</>
	);
};

const HeaderCard = ({ type, nameselect, icon }) => {
	if (type === menuSelect.principal) {
		return (
			<div>
				<div className="flex justify-center items-center mb-2">
					<img className="w-[160px] h-[119px]" src={Assets.general.logomenu1} alt="logonegro" />
				</div>
				<div className="pl-10 text-[20px]">
					<p className="regularFont">
						Bienvenido a <span className="font-bold">Universidad</span>
					</p>
					<p className="font-extrabold">Autonoma Metropolitana</p>
				</div>
			</div>
		);
	} else {
		return (
			<div className="flex items-center gap-4">
				<div className="h-[25px] w-[25px]">
					<img className="h-full w-full" src={icon} alt="imagen" />
				</div>
				<div className="text-secondary font-bold text-[20px]">
					<span className="">{nameselect}</span>
				</div>
			</div>
		);
	}
};
